export default __webpack_public_path__ + "static/media/masteringReactHooks.5e9728e0.md";